import { query } from '@/services/GraphqlService';

import preRegistrationByLocalQuery from '@/graphql/preRegistration/preRegistrationByLocalQuery.gql';

export const getPreRegistrationByLocal = (apollo, localId) =>
  query(apollo, preRegistrationByLocalQuery, { id: localId });
